import Show from '@/ui/components/helpers/Show'
import { InputTag, MultiTagInput } from '@/ui/components/multi-tag-input'
import { FC, RefObject } from 'react'
import { Body } from './addDomain.styles'
import { NUM_OF_DOMAINS_ALLOWED, TAddDomainTag } from './useAddDomain'
import Typography from '@/ui/components/typography'

type TAddDomainProps = {
    domains: TAddDomainTag[]
    onDomainAdd: (tag: TAddDomainTag) => Promise<void>
    inputDisabled: boolean
    onDomainEdit: (tag: TAddDomainTag) => Promise<void>
    removeTagFromDomains: (tag: TAddDomainTag) => void
    domainCheckValue: string
    addDomainsError: string | null
    domainInputRef: RefObject<HTMLInputElement>
}

const AddDomain: FC<TAddDomainProps> = ({
    domains,
    onDomainAdd,
    inputDisabled,
    onDomainEdit,
    removeTagFromDomains,
    domainCheckValue,
    addDomainsError,
    domainInputRef,
}) => {
    return (
        <Body data-testid="add-domain">
            <Typography component="p" variant="l-regular">
                Add Domains
            </Typography>
            <p className="note">
                Add or confirm domains from our suggestions or input your own.
                These will be added to your account for comprehensive security
                monitoring.
            </p>
            <MultiTagInput<TAddDomainTag>
                tags={domains}
                tagInputRef={domainInputRef}
                capacity={NUM_OF_DOMAINS_ALLOWED}
                placeholder="Enter domain URL's"
                onTagEnter={onDomainAdd}
                onTagEdit={onDomainEdit}
                inputDisabled={inputDisabled}
                renderTag={(tag, _index, onTagEdit: any) => (
                    <InputTag
                        key={tag.id}
                        id={tag.id}
                        value={tag.value}
                        className={tag.is_valid ? 'is-valid' : 'is-invalid'}
                        onRemove={() => removeTagFromDomains(tag)}
                        clickable={!tag.is_valid}
                        onTagEdit={onTagEdit}
                    />
                )}
            />
            <div className="msg-container">
                <Show when={!!domainCheckValue && !!addDomainsError}>
                    <div className="error">
                        <b>{domainCheckValue}:</b> {addDomainsError}
                    </div>
                </Show>
            </div>
            <div className="example">
                <p className="title">Acceptable domain URL input format:</p>
                <ul>
                    <li>yourdomain.com</li>
                    <li>yourdomain2.com</li>
                </ul>
            </div>
        </Body>
    )
}

export default AddDomain
